import { render, staticRenderFns } from "./modalRdasConsulta.vue?vue&type=template&id=33eef01b&scoped=true"
import script from "./modalRdasConsulta.vue?vue&type=script&lang=js"
export * from "./modalRdasConsulta.vue?vue&type=script&lang=js"
import style0 from "./modalRdasConsulta.vue?vue&type=style&index=0&id=33eef01b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eef01b",
  null
  
)

export default component.exports